var _path, _circle, _path2, _circle2, _rect, _rect2, _rect3, _rect4, _polyline, _polyline2, _polyline3, _circle3, _circle4, _polyline4, _polyline5, _polyline6, _circle5, _circle6, _circle7, _line, _path3, _path4, _path5, _path6, _path7, _path8, _circle8, _ellipse, _polygon, _path9, _path10, _path11, _polygon2, _path12, _polygon3, _path13, _path14, _circle9, _path15, _polygon4, _path16, _path17, _path18, _polygon5, _polygon6, _polygon7, _polygon8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationtracking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e7b3b0c3-1e4f-480c-906c-c03021e90d10",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 991.13988,
    height: 770.17774,
    viewBox: "0 0 991.13988 770.17774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "professor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M394.01076,64.91113,236.15757,150.41336a40.156,40.156,0,1,1-70.5866,38.23373l-53.82344,29.15382L251.16683,475.1951,533.43006,322.30535Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#f2f2f2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 94.60365,
    cy: 105.66791,
    r: 32.5874,
    fill: "#009ddd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M790.38464,753.97532l170.67214-55.67116a40.156,40.156,0,1,1,76.31882-24.89429l58.19434-18.98228-90.777-278.29668L699.60765,475.6786Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 896.77566,
    cy: 620.24394,
    r: 32.5874,
    fill: "#009ddd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 152.67774,
    width: 788,
    height: 358,
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 128.5,
    y: 165.67774,
    width: 762,
    height: 325,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 739,
    y: 475.17774,
    width: 74,
    height: 25,
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 681,
    y: 494.17774,
    width: 54,
    height: 7,
    fill: "#009ddd"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "190.5 288.678 481.5 288.678 526.616 310.657 598.5 345.678 645.5 257.678 778.5 257.678",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "304.925 288.678 326.5 339.678 379.5 339.678",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    points: "385.807 288.678 459.5 248.678 511.5 248.678",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 304.5,
    cy: 288.67774,
    r: 9,
    fill: "#009ddd"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 388.5,
    cy: 288.67774,
    r: 9,
    fill: "#009ddd"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    points: "526.5 310.678 532.5 399.678 584.5 399.678",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    points: "626.65 292.971 569.5 248.678 623.5 248.678",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _polyline6 || (_polyline6 = /*#__PURE__*/React.createElement("polyline", {
    points: "721.051 257.678 776.5 301.678 828.5 301.678",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 526.5,
    cy: 310.67774,
    r: 9,
    fill: "#009ddd"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 720.5,
    cy: 257.67774,
    r: 9,
    fill: "#009ddd"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 626.5,
    cy: 292.67774,
    r: 9,
    fill: "#009ddd"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 327.5,
    y1: 347.67774,
    x2: 379.5,
    y2: 347.67774,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M615.93006,322.58887h0Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M727.93006,321.58887h0Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M727.93006,329.58887h0Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M932.93006,374.58887h0Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M913.93006,382.58887h0Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M688.93006,472.58887h0Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 809.54207,
    cy: 75.52974,
    r: 14.75556,
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 152,
    cy: 742.17774,
    rx: 152,
    ry: 28,
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "256.389 493.658 229.272 507.339 231.027 510.834 258.143 497.153 256.389 493.658",
    fill: "#009ddd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M356.41026,533.12245l-1.21823,7.3094s1.82735,50.55672-11.57323,34.71968-4.26382-37.15614-4.26382-37.15614l3.65471-6.09117Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#fbbebe"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M278.44328,299.22149s-2.43647,25.58291-3.65471,26.80115,18.27352,24.36468,18.27352,24.36468l17.05527-15.837s-1.21823-23.14645,2.43647-28.01939S278.44328,299.22149,278.44328,299.22149Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#fbbebe"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M278.44328,299.22149s-2.43647,25.58291-3.65471,26.80115,18.27352,24.36468,18.27352,24.36468l17.05527-15.837s-1.21823-23.14645,2.43647-28.01939S278.44328,299.22149,278.44328,299.22149Z",
    transform: "translate(-104.43006 -64.91113)",
    opacity: 0.1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "128.939 700.894 128.939 722.822 120.411 724.041 108.229 720.386 111.883 697.239 128.939 700.894",
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M222.4045,776.76929s-3.6547-9.74588-9.74587-8.52764-7.30941,8.52764-7.30941,8.52764-4.87293,18.27351-12.18234,24.36468-14.61881,21.92822,0,24.36468,26.80115-3.6547,26.80115-4.87293,3.65471-8.52764,9.74588-9.74588,10.96411-2.43646,10.96411-7.3094-3.65471-9.74587-3.65471-9.74587-1.21823-23.10808-3.6547-20.08168a24.23422,24.23422,0,0,0-3.6547,7.89933Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "181.323 689.93 176.45 708.203 188.632 710.64 194.723 704.549 195.941 688.712 181.323 689.93",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M284.53445,770.67812s4.87293-3.65471,7.3094-3.65471h3.6547s0-8.52764,6.09118-8.52764,4.87293,6.09117,4.87293,6.09117,13.40058,20.71,17.05528,24.36469,23.14645,14.61881,7.30941,19.49175-26.80116,4.87293-34.11056-3.65471c0,0-7.30941-3.6547-12.18234-3.6547s-10.96411-2.43647-10.96411-6.09117,3.6547-10.96411,3.6547-10.96411,2.43647-21.92821,3.6547-19.49175S284.53445,770.67812,284.53445,770.67812Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M232.15038,474.64721v40.20173s-13.40058,77.967-13.40058,103.5499-20.71,147.40634-10.96411,149.84281,32.89233,6.09117,34.11056,2.43647,9.74587-119.387,10.96411-120.60519,26.80115-97.45873,26.80115-97.45873l4.87294,1.21823,2.43646,109.64108s-12.18234,98.677-6.09117,98.677,31.67409-1.21824,31.67409-8.52764,13.40058-142.5334,13.40058-142.5334,15.837-107.20461,9.74587-118.16872-6.09117-17.05528-6.09117-17.05528Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#2f2e41"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 194.11408,
    cy: 228.8283,
    r: 24.36468,
    fill: "#fbbebe"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M293.06209,335.76851s-15.22793-12.79146-16.44617-17.66439c0,0-7.91852,7.91852-7.91852,9.13675s-34.11056,4.87294-42.63819,14.61881-15.83705,30.45586-15.83705,30.45586l20.71,38.98349s1.21824,21.92822,1.21824,24.36468-6.09117,41.42-3.65471,42.6382,26.80116,13.40058,47.51114,10.96411,41.42-6.09117,47.51113-6.09117,10.96411,2.43647,10.96411,0-3.6547-7.30941-3.6547-9.74588-1.21824-8.52764-1.21824-12.18234-2.43647-9.74587-2.43647-14.61881,26.80116-70.65758,26.80116-70.65758-1.21824-20.71-20.71-30.45586-21.92821-13.40057-21.92821-13.40057-.37979-7.30941-1.40813-7.30941-4.683,10.96411-14.42892,12.18235Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#d0cde1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.847 432.883 131.375 446.283 153.303 441.41 137.466 423.137 122.847 432.883",
    fill: "#fbbebe"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M346.66439,366.22437l7.30941,9.74587s14.61881,70.65758,12.18234,96.2405-4.87294,45.07466-4.87294,45.07466,4.87294,18.27352,1.21823,18.27352-25.58291,1.21823-25.58291-2.43647S339.355,506.3213,339.355,506.3213L333.26381,452.719l-13.40057-18.27351Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#d0cde1"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M281.99544,281.91075c1.4935-.633,3.22007-.1195,4.81953-.38952,1.87824-.31708,3.55879-1.70862,5.45549-1.533a10.48375,10.48375,0,0,1,2.5973.84328,3.39062,3.39062,0,0,0,2.66075.09529,1.51214,1.51214,0,0,0,.57862-2.27113,7.52045,7.52045,0,0,0,4.32739-1.86276,3.22984,3.22984,0,0,1,.82584-.61957,2.69555,2.69555,0,0,1,2.12237.33059l2.78767,1.285a3.52582,3.52582,0,0,1,1.593,1.13954c.33158.517.39648,1.21219.86613,1.60806.59923.50509,1.495.25792,2.27711.30743a2.91242,2.91242,0,0,1,2.62978,2.83983c-.01108.81805-.30863,1.82167.33839,2.32234.37528.29039.90808.24392,1.34773.42241,1.13946.4626,1.1439,2.04883.97555,3.267s-.08506,2.82525,1.08613,3.20033c.82465.2641,1.66742-.29891,2.52418-.42448,1.29251-.18944,2.48848.619,3.63908,1.23756s2.67915,1.03581,3.67643.19207c.928-.78513.86846-2.2215.61327-3.41a18.78968,18.78968,0,0,0-1.78747-4.88693,3.102,3.102,0,0,1-.51817-1.52085,2.75375,2.75375,0,0,1,1.27792-1.86007c1.40979-1.11453,3.03151-2.23658,3.4879-3.97479.335-1.27571-.04182-2.62112-.01273-3.93975.03541-1.60454.6734-3.20218.3742-4.779-.54233-2.85815-3.72326-4.23367-5.77661-6.29447-2.82154-2.83179-3.7376-7.36107-7.06749-9.57284-2.6639-1.76941-6.14831-1.55819-9.18183-2.57056-3.33241-1.11211-6.01486-3.6671-9.302-4.90659a12.96261,12.96261,0,0,0-11.01889.96648,11.02841,11.02841,0,0,1-3.23948,1.65513,11.64687,11.64687,0,0,1-2.94852-.0342,11.3814,11.3814,0,0,0-5.6235,1.16027,3.14415,3.14415,0,0,0-1.57539,1.38165c-.58852,1.30709.26647,3.35047-1.02358,3.97545-.60147.29139-1.31155.01224-1.97973.02691-1.29933.02853-2.29894,1.15915-2.91719,2.30232a11.03264,11.03264,0,0,1-2.04409,3.28973c-1.58825,1.391-4.47379,1.62087-4.88876,3.69094a20.12443,20.12443,0,0,0,.149,2.62234c-.12,1.8345-2.08321,3.2287-1.98075,5.06426.11819,2.11725,2.80817,3.15168,3.52724,5.14658.54753,1.519-.173,3.1614-.66878,4.698s-.6453,3.50622.63511,4.4899c.50206.38571,1.14756.54384,1.65956.91623,1.32492.96364,1.30819,2.90835,1.16106,4.54a2.13535,2.13535,0,0,0,.48137,1.944,1.79886,1.79886,0,0,0,1.47242.17681,6.00977,6.00977,0,0,0,3.8037-2.86237c.42668-.70547.51243-1.32725,1.28754-1.70157.52595-.254,1.16463-.02729,1.7-.35691C279.74623,287.70916,278.86947,283.2356,281.99544,281.91075Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M213.87686,368.66083l-3.6547,3.65471S188.294,438.10018,195.60335,452.719s21.92822,51.16584,26.80115,49.9476,21.92822-12.18234,21.92822-13.40057-20.71-35.32879-20.71-35.32879-2.43647-7.30941-1.21824-8.52764,1.21824,0,0-2.43647-1.21823,0,1.21824-2.43647,2.43647-2.43647,2.43647-3.6547,7.3094-31.67409,7.3094-31.67409Z",
    transform: "translate(-104.43006 -64.91113)",
    fill: "#d0cde1"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "128.329 446.892 155.131 438.365 158.785 446.892 129.548 452.983 128.329 446.892",
    fill: "#2f2e41"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "128.329 446.892 155.131 438.365 158.785 446.892 129.548 452.983 128.329 446.892",
    opacity: 0.1
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "164.876 262.939 185.586 279.994 188.023 276.339 164.876 262.939",
    opacity: 0.1
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "206.296 267.812 191.678 276.339 192.896 279.994 206.296 267.812",
    opacity: 0.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationtracking);
export default __webpack_public_path__ + "static/media/locationtracking.b90a89c4a3a8cf6aa722cbf754458259.svg";
export { ForwardRef as ReactComponent };